// extracted by mini-css-extract-plugin
export default {"cls1":"s6HyAQOtduv3UBb0NJMQ","cls2":"c0TlDIkP7Fq7SjUmrKF_ s6HyAQOtduv3UBb0NJMQ"};